import { render, staticRenderFns } from "./ChooseBranch.vue?vue&type=template&id=3a2b0dc7&"
import script from "./ChooseBranch.vue?vue&type=script&lang=js&"
export * from "./ChooseBranch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports